import React from "react";
import DOMPurify from "dompurify";
import styles from "./CSS/ToastCenterTop.module.css";
import { useUIContext } from "../context/UIContext";

export default function ToastCenterTop() {
  const { toastCenterTop } = useUIContext();

  if (!toastCenterTop.visible) return null;

  const toastStyle = {
    backgroundColor: toastCenterTop.color || "#198754", // 기본 색상 유지
  };

  return (
    <div
      className={styles.toastCenterTop}
      style={toastStyle}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(toastCenterTop.message),
      }}
    />
  );
}
